import React from 'react';

const Icon = (props) => {
    return (
        <div
            onClick={() => props.visibleComp()}
            style={{paddingTop: 20, paddingLeft: '2rem', display: 'flex', flexDirection: 'column', width: '6%', alignItems: 'center'}}>
            <img 
                alt="Icon"
                src={props.image}
                style={{ height: '60px', marginLeft: 12, padding: 10 }}
            />
            
            <h1 style={{fontWeight: 'bold', color: "#FFF", paddingLeft: 10}}>{props.title}</h1>
        </div>
    );
}

export default Icon;
